/* Yanash brand homepage behaviour (2026-10-06): hero deal, guess game, family clips, edition waitlist. */
(function () {
  var root = document.querySelector('.hx');
  if (!root) return;
  var D = JSON.parse(document.getElementById('hxData').textContent);
  var still = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal on scroll */
  var rv = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); rv.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -10% 0px' });
  root.querySelectorAll('[data-rv]').forEach(function (el) { rv.observe(el); });

  /* Hero: cards finish dealing, then idle; the stage leans toward the pointer */
  var fan = root.querySelectorAll('.hx-fan .kl');
  fan.forEach(function (k) { k.addEventListener('animationend', function f(e) { if (e.animationName === 'hxDeal') { k.classList.add('idle'); k.removeEventListener('animationend', f); } }); });
  var stage = document.getElementById('hxStage');
  if (stage && !still && matchMedia('(pointer:fine)').matches) {
    var inner = stage.querySelector('.hx-boxes'), f2 = stage.querySelector('.hx-fan');
    stage.closest('.hx-hero').addEventListener('pointermove', function (e) {
      var r = stage.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      f2.style.transform = 'translate(' + (x * -14) + 'px,' + (y * -10) + 'px)';
      inner.style.transform = 'translateX(-50%) translate(' + (x * 10) + 'px,' + (y * 6) + 'px)';
    });
  }

  /* Coming-soon carousel: drifts one box at a time while on screen, stops for good once someone swipes it */
  var car = document.getElementById('hxCar');
  if (car && !still) {
    var items = [].slice.call(car.querySelectorAll('li')), ci = 0, timer = null, live = true;
    var step = function () {
      ci = (ci + 1) % items.length;
      var r = items[ci].getBoundingClientRect(), c = car.getBoundingClientRect();
      car.scrollBy({ left: (r.left + r.width / 2) - (c.left + c.width / 2), behavior: 'smooth' });
    };
    var stop = function () { live = false; clearInterval(timer); timer = null; };
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (t) { car.addEventListener(t, stop, { passive: true }); });
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting && live && !timer && car.scrollWidth > car.clientWidth + 8) timer = setInterval(step, 2800);
        else if (!e.isIntersecting) { clearInterval(timer); timer = null; }
      });
    }, { threshold: .6 }).observe(car);
  }

  /* Shop cards and hero rows add to the cart through yansh-cart.js (form[data-yn-cart]) and open the shared side cart. */

  /* Mobile buy bar: appears once the hero is gone, hides again while the shop section or the footer is on screen */
  var bb = document.getElementById('hxBuybar'), hero = root.querySelector('.hx-hero'), shop = document.getElementById('kufsaot');
  if (bb && hero && shop) {
    var st = { hero: true, shop: false };
    var sync = function () { var on = !st.hero && !st.shop; bb.classList.toggle('on', on); bb.setAttribute('aria-hidden', on ? 'false' : 'true'); bb.querySelector('a').tabIndex = on ? 0 : -1; };
    new IntersectionObserver(function (es) { es.forEach(function (e) { st[e.target === hero ? 'hero' : 'shop'] = e.isIntersecting; }); sync(); }, { threshold: 0 }).observe(hero);
    new IntersectionObserver(function (es) { es.forEach(function (e) { st.shop = e.isIntersecting; }); sync(); }, { threshold: 0 }).observe(shop);
  }

  /* Guess game */
  var deck = document.getElementById('hxDeck');
  if (deck) {
    var cards = [].slice.call(deck.querySelectorAll('.flip')), Q = D.quiz, n = 0, score = 0;
    var opts = document.getElementById('hxOpts'), fb = document.getElementById('hxFb'), nw = document.getElementById('hxNextWrap'),
        end = document.getElementById('hxEnd'), qn = document.getElementById('hxQn'), qs = document.getElementById('hxQs');
    var L = ['א', 'ב', 'ג'];
    var layout = function () {
      cards.forEach(function (c, i) {
        c.classList.remove('cur', 'n1', 'n2', 'n3', 'n4', 'gone');
        if (i < n) c.classList.add('gone');
        else if (i === n) c.classList.add('cur');
        else c.classList.add('n' + Math.min(i - n, 4));
      });
    };
    var flip = function (c, on) { c.setAttribute('aria-pressed', on ? 'true' : 'false'); };
    var round = function () {
      layout(); qn.textContent = n + 1; qs.textContent = score;
      fb.hidden = true; nw.hidden = true; opts.innerHTML = '';
      Q[n].opts.forEach(function (t, i) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'hx-opt'; b.dataset.l = L[i]; b.textContent = t;
        b.addEventListener('click', function () { answer(i); }); opts.appendChild(b);
      });
    };
    var answer = function (i) {
      var ok = Q[n].ok, bs = opts.querySelectorAll('.hx-opt');
      bs.forEach(function (b, j) { b.disabled = true; if (j === ok) b.classList.add('ok'); else if (j === i) b.classList.add('no'); else b.classList.add('dim'); });
      if (i === ok) score++;
      qs.textContent = score;
      fb.textContent = i === ok ? 'בול. הפכו את הקלף: התכלס ומתי שולפים מחכים בגב.' : 'כמעט. ככה בדיוק נשמע ערב עם יאנאש. תראו בגב הקלף מה זה אומר באמת.';
      fb.hidden = false;
      flip(cards[n], true);
      if (n < cards.length - 1) nw.hidden = false;
      else setTimeout(function () { end.hidden = false; }, 700);
    };
    cards.forEach(function (c) { c.addEventListener('click', function () { flip(c, c.getAttribute('aria-pressed') !== 'true'); }); });
    document.getElementById('hxNext').addEventListener('click', function () { flip(cards[n], false); n++; round(); });
    document.getElementById('hxAgain').addEventListener('click', function () {
      cards.forEach(function (c) { flip(c, false); }); n = 0; score = 0; end.hidden = true; round();
    });
    round();
  }

  /* Family clips: load when near, play muted while visible, tap for sound (one at a time) */
  var vids = [].slice.call(root.querySelectorAll('.hx-vid'));
  var vo = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target.querySelector('video');
      if (e.isIntersecting) {
        if (!v.src) { v.src = D.ugc[v.dataset.file]; }
        if (!still) v.play().catch(function () {});
      } else { v.pause(); }
    });
  }, { threshold: .55 });
  vids.forEach(function (b) {
    vo.observe(b);
    b.addEventListener('click', function () {
      var v = b.querySelector('video'), on = !b.classList.contains('on');
      vids.forEach(function (o) { o.classList.remove('on'); o.querySelector('video').muted = true; });
      if (!v.src) v.src = D.ugc[v.dataset.file];
      if (on) { b.classList.add('on'); v.muted = false; v.currentTime = 0; v.play().catch(function () {}); }
    });
  });

  /* Edition waitlist: first name, email, edition -> Klaviyo list + event */
  var dlg = document.getElementById('hxWl'), form = document.getElementById('hxWlForm'), sel = document.getElementById('hxWlEd'),
      other = document.getElementById('hxWlOther'), boxSlot = document.getElementById('hxWlBox'), err = document.getElementById('hxWlErr');
  var copy = function () {
    var e = D.editions[sel.value];
    other.hidden = sel.value !== 'other';
    document.getElementById('hxWlH').textContent = sel.value === 'other' ? 'איזו קופסה חסרה לכם?' : 'שמרו לי את הקופסה ' + e.in;
    document.getElementById('hxWlP').textContent = sel.value === 'other'
      ? 'ספרו לנו מאיזה בית אתם. המהדורה הבאה נבחרת לפי מה שהכי הרבה משפחות מבקשות.'
      : 'נעדכן אתכם ראשונים כשהקופסה ' + e.in + ' יוצאת, לפני כולם.';
  };
  var setBox = function (ed) {
    var src = root.querySelector('[data-box="' + ed + '"]') || (ed === 'other' && root.querySelector('.hx-pc-q'));
    boxSlot.innerHTML = ''; if (src) { var c = src.cloneNode(true); c.removeAttribute('loading'); boxSlot.appendChild(c); }
  };
  var open = function (ed) {
    sel.value = ed; copy(); setBox(ed);
    document.getElementById('hxWlFields').hidden = false; document.getElementById('hxWlOk').hidden = true; err.hidden = true;
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    setTimeout(function () { form.first_name.focus(); }, 60);
  };
  root.querySelectorAll('[data-wl]').forEach(function (b) { b.addEventListener('click', function () { open(b.dataset.wl); }); });
  sel.addEventListener('change', function () { copy(); setBox(sel.value); });
  dlg.querySelectorAll('[data-wl-close]').forEach(function (b) { b.addEventListener('click', function () { dlg.close(); }); });
  dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });

  var K = 'https://a.klaviyo.com/client/', H = { 'Content-Type': 'application/vnd.api+json', revision: '2025-07-15' };
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var name = form.first_name.value.trim(), email = form.email.value.trim(), ed = sel.value, req = form.request.value.trim();
    if (!name || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.textContent = 'צריך שם פרטי ומייל תקין.'; err.hidden = false; return; }
    if (ed === 'other' && !req) { err.textContent = 'ספרו לנו איזו מהדורה חסרה לכם.'; err.hidden = false; return; }
    err.hidden = true;
    var go = document.getElementById('hxWlGo'); go.disabled = true; go.textContent = 'שומרים לכם מקום...';
    var props = { edition_interest: ed, edition_interest_name: D.editions[ed].name };
    props['waitlist_' + ed] = true;
    if (req) props.edition_request = req;
    var sub = fetch(K + 'subscriptions?company_id=' + D.klaviyo.company, { method: 'POST', headers: H, body: JSON.stringify({ data: { type: 'subscription', attributes: {
      custom_source: 'Homepage edition waitlist',
      profile: { data: { type: 'profile', attributes: { email: email, first_name: name, properties: props } } } },
      relationships: { list: { data: { type: 'list', id: D.klaviyo.list } } } } }) });
    var ev = fetch(K + 'events?company_id=' + D.klaviyo.company, { method: 'POST', headers: H, body: JSON.stringify({ data: { type: 'event', attributes: {
      properties: { edition: ed, edition_name: D.editions[ed].name, request: req || null, source: 'homepage' },
      metric: { data: { type: 'metric', attributes: { name: 'Joined Edition Waitlist' } } },
      profile: { data: { type: 'profile', attributes: { email: email, first_name: name } } } } } }) });
    Promise.all([sub, ev]).then(function (rs) {
      if (!rs[0].ok) throw new Error('sub ' + rs[0].status);
      document.getElementById('hxWlFields').hidden = true;
      document.getElementById('hxWlOk').hidden = false;
      document.getElementById('hxWlOkP').textContent = ed === 'other'
        ? 'תודה, ' + name + '. רשמנו את הבקשה שלכם, ונעדכן אם המהדורה הזאת יוצאת לדרך.'
        : 'תודה, ' + name + '. כשהקופסה ' + D.editions[ed].in + ' יוצאת, אתם הראשונים לדעת.';
    }).catch(function () {
      err.textContent = 'משהו השתבש. נסו שוב, או כתבו לנו ל-niflaot@yanash.com.'; err.hidden = false;
    }).then(function () { go.disabled = false; go.textContent = 'תודיעו לי ראשונים'; });
  });
})();

/* Hero "pick your box" (2026-10-10): edition toggle + quantity; the button always shows what lands in the cart */
(function(){
  var n3=document.querySelector('.n3');if(!n3)return;
  var E=JSON.parse(n3.querySelector('script[type="application/json"]').textContent),st=n3.querySelector('.n3-stage'),f=n3.querySelector('form'),btn=f.querySelector('.nh-cta span');
  function price(){var q=f.querySelector('input[name=quantity]:checked');btn.textContent='הוספה לסל · '+q.getAttribute('data-total')+' ₪'}
  f.addEventListener('change',price);
  n3.querySelectorAll('.n3-tog button').forEach(function(b){b.addEventListener('click',function(){var ed=b.dataset.ed;if(n3.dataset.ed===ed)return;
    n3.querySelectorAll('.n3-tog button').forEach(function(o){o.setAttribute('aria-pressed',o===b)});n3.dataset.ed=ed;st.classList.add('sw');
    setTimeout(function(){var e=E[ed];st.querySelector('.n3-box').src=e.box;st.querySelectorAll('.c img').forEach(function(im,i){im.src=e.cards[i]});n3.querySelector('.n3-sub').textContent=e.sub;f.querySelector('input[name=id]').value=e.id;st.classList.remove('sw')},320)})});
})();

/* Box builder (2026-10-28): every live box card adds to one tray. Five slots, the 3rd and 5th are the gifts; the tray
   prices the set with window.ynOff (yansh-cart-drawer.liquid) and adds it to the cart in one call. */
(function(){
  var grid=document.getElementById('hxb'),tray=document.getElementById('hxbTray');if(!grid||!tray)return;
  var U=Number(grid.getAttribute('data-unit')),q={},order=[];
  var cards=[].slice.call(grid.querySelectorAll('.hxb-add'));
  var MSG=['בחרו קופסאות. <b>השלישית עלינו.</b>','עוד 2 קופסאות, <b>והשלישית מתנה.</b>','<b>הקופסה הבאה מתנה.</b> בחרו אותה מכל שפה.',
    '<b>קיבלתם קופסה מתנה.</b> עוד 2 ומקבלים שתיים.','<b>גם הקופסה הבאה מתנה.</b>','<b>שתי קופסאות מתנה.</b> המארז הכי משתלם.'];
  function off(n){return window.ynOff?window.ynOff(n):0}
  function n(){return order.length}
  function upd(){
    cards.forEach(function(c){var v=c.getAttribute('data-vid'),k=q[v]||0;
      c.querySelector('.hxb-plus').hidden=k>0;c.querySelector('.hxb-q').hidden=!k;c.querySelector('.hxb-q span').textContent=k;
      c.closest('.hx-pc').classList.toggle('hxb-on',k>0)});
    [].forEach.call(tray.querySelectorAll('.hxb-sl'),function(sl,i){var v=order[i];
      sl.classList.toggle('full',!!v);sl.style.backgroundImage=v?'url("'+grid.querySelector('[data-vid="'+v+'"]').getAttribute('data-img')+'")':''});
    var k=n(),full=U*k,tot=full-off(k);
    tray.querySelector('.hxb-msg').innerHTML=MSG[Math.min(k,5)]+(k>5?' ('+k+' קופסאות)':'');
    var go=tray.querySelector('.hxb-go');go.disabled=!k;
    go.querySelector('b').innerHTML=k?(off(k)?'<s><bdi>'+full/100+' ₪</bdi></s> ':'')+'<bdi>'+tot/100+' ₪</bdi>':'';
  }
  grid.addEventListener('click',function(e){
    var b=e.target.closest('.hxb-plus,[data-d]');if(!b)return;
    var v=b.closest('.hxb-add').getAttribute('data-vid'),d=b.hasAttribute('data-d')?Number(b.getAttribute('data-d')):1;
    if(d>0){q[v]=(q[v]||0)+1;order.push(v)}
    else if(q[v]){q[v]--;order.splice(order.lastIndexOf(v),1)}
    upd();
  });
  tray.querySelector('.hxb-go').addEventListener('click',function(){
    if(!n()||!window.ynCart)return;var go=this;go.setAttribute('aria-busy','true');
    var items=Object.keys(q).filter(function(v){return q[v]}).map(function(v){return {id:Number(v),quantity:q[v]}});
    ynCart.add(items).then(function(){q={};order=[];go.removeAttribute('aria-busy');upd()}).catch(function(){go.removeAttribute('aria-busy')});
  });
  document.addEventListener('click',function(e){
    var a=e.target.closest('[data-hxb-go]');if(!a)return;e.preventDefault();
    document.getElementById('kufsaot').scrollIntoView({behavior:'smooth',block:'start'});
    tray.classList.remove('pulse');void tray.offsetWidth;tray.classList.add('pulse');
  });
  upd();
})();
